document.documentElement.classList.remove('no-js');

function money(cents, format) {
  const value = (cents / 100).toFixed(2);
  if (format && format.includes('{{amount_no_decimals}}')) return format.replace('{{amount_no_decimals}}', Math.round(cents/100));
  return format ? format.replace('{{amount}}', value) : '$' + value;
}

document.addEventListener('click', (e) => {
  const q = e.target.closest('[data-qty]');
  if (q) {
    const wrap = q.closest('.quantity');
    const input = wrap.querySelector('input');
    const next = Math.max(1, Number(input.value || 1) + Number(q.dataset.qty));
    input.value = next;
  }
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-root]').forEach(root => {
    const variants = JSON.parse(root.querySelector('[data-variants-json]').textContent);
    const form = root.querySelector('form[action*="/cart/add"]');
    const idInput = form && form.querySelector('[name="id"]');
    const price = root.querySelector('[data-price]');
    const compare = root.querySelector('[data-compare]');
    const save = root.querySelector('[data-save]');
    const add = root.querySelector('[data-add-button]');
    const sticky = document.querySelector('[data-sticky-atc]');
    const stickyPrice = sticky && sticky.querySelector('[data-sticky-price]');
    const moneyFormat = root.dataset.moneyFormat;

    function selectedOptions(){
      return [...root.querySelectorAll('[data-option-index]')].map(group => {
        const active = group.querySelector('[aria-pressed="true"]');
        return active ? active.dataset.value : null;
      });
    }
    function updateVariant(){
      const opts = selectedOptions();
      const variant = variants.find(v => v.options.every((o,i)=>o===opts[i]));
      if (!variant) return;
      idInput.value = variant.id;
      if(price) price.textContent = money(variant.price, moneyFormat);
      if(stickyPrice) stickyPrice.textContent = money(variant.price, moneyFormat);
      if(compare){
        compare.textContent = variant.compare_at_price && variant.compare_at_price > variant.price ? money(variant.compare_at_price, moneyFormat) : '';
        compare.style.display = compare.textContent ? '' : 'none';
      }
      if(save){
        if(variant.compare_at_price && variant.compare_at_price > variant.price){
          save.textContent = 'SAVE ' + Math.round((1 - variant.price/variant.compare_at_price)*100) + '%';
          save.style.display = '';
        } else save.style.display = 'none';
      }
      if(add){add.disabled=!variant.available; add.textContent=variant.available ? add.dataset.availableText : add.dataset.soldText;}
      const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); history.replaceState({},'',url);
    }
    root.querySelectorAll('.option__button').forEach(btn=>btn.addEventListener('click',()=>{
      const group=btn.closest('[data-option-index]');
      group.querySelectorAll('.option__button').forEach(x=>x.setAttribute('aria-pressed','false'));
      btn.setAttribute('aria-pressed','true');
      const label=group.querySelector('[data-selected-value]'); if(label) label.textContent=btn.dataset.value;
      updateVariant();
    }));

    if(sticky && form){
      const io = new IntersectionObserver(entries => {
        entries.forEach(entry => sticky.classList.toggle('is-visible', !entry.isIntersecting));
      }, {threshold:.1});
      io.observe(form);
      const stickyBtn=sticky.querySelector('[data-sticky-button]');
      if(stickyBtn) stickyBtn.addEventListener('click',()=>add && add.click());
    }
  });
});